import React from 'react';
import { Button } from 'shards-react';
import { RootState, useDispatch, useSelector } from '../../../redux/store';
import { setDialogMode, openDialog, selectOrganization } from '../../../redux/slices/organization';
import { useTranslation } from 'react-i18next';

const AddOrganization = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  /**
   * 組織の新規作成
   */
  const handleAddOrganization = (): void => {
    dispatch(selectOrganization());
    dispatch(setDialogMode('CREATE'));
    dispatch(openDialog());
  };

  // VIEW
  // ================================================================================

  return (
    <Button className="mr-2" theme="white" onClick={handleAddOrganization}>
      <i className="material-icons">add</i>
      {t('organization.add')}
    </Button>
  );
};

export default AddOrganization;
